function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { Path, Rect } from "react-native-svg";
var SvgIcCarePlan = function SvgIcCarePlan(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 20,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement(Path, {
    fill: props.fillLineInverted,
    fillRule: "evenodd",
    d: "M4.5 4h4v5h3v3h2v4h-9z",
    clipRule: "evenodd",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement(Path, {
    fill: props.accentFillLine,
    fillRule: "evenodd",
    d: "M4.5 2h7v2h-7v12h9v-4h2v4a2 2 0 0 1-2 2h-9a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement(Path, {
    fill: props.accentFillLine,
    fillRule: "evenodd",
    d: "M15.5 5V2h-3v3h-3v3h3v3h3V8h3V5z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement(Rect, {
    width: 7,
    height: 2,
    x: 5.5,
    y: 12,
    fill: props.accentFillLine,
    rx: 1
  }), /*#__PURE__*/React.createElement(Path, {
    fill: props.accentFillLine,
    d: "M5.5 10a1 1 0 0 1 1-1h5v2h-5a1 1 0 0 1-1-1M5.5 7a1 1 0 0 1 1-1h2v2h-2a1 1 0 0 1-1-1"
  }));
};
export default SvgIcCarePlan;